import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, class_type, option_type, record_type, int32_type, union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Default", "Search"];
    }
}

export function Page$reflection() {
    return union_type("Containers.NumberInventory.Model.Page", [], Page, () => [[], [["Item", string_type]]]);
}

export class NetworkContractNrAndNameDTO extends Record {
    constructor(NetworkContractNr, NetworkName) {
        super();
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.NetworkName = NetworkName;
    }
}

export function NetworkContractNrAndNameDTO$reflection() {
    return record_type("Containers.NumberInventory.Model.NetworkContractNrAndNameDTO", [], NetworkContractNrAndNameDTO, () => [["NetworkContractNr", int32_type], ["NetworkName", string_type]]);
}

export class NumberSerieDTO extends Record {
    constructor(ClientNr, CountryCode, NumberFrom, Version, NumberTo, NetworkContractNr, NumberCategory, ReservedBy, ReservedDate, ReservedOptionForContractNr, ReservedRemark, UnavailableBy, UnavailableDate, UnavailableReason, ActiveVersion, ActiveFrom, ActiveTo, QuarantineTo, ContractNr, Langd, NetworkIntegrationNr, NetworkIntegrationName, ActionEdit, ActionUndoQuarantine, ActionGotoContract, ActionQuarantine, ActionRegister, ActionReserved, ActionUnavailable, ActionUndoReserved, ActionUnregister) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.CountryCode = CountryCode;
        this.NumberFrom = NumberFrom;
        this.Version = Version;
        this.NumberTo = NumberTo;
        this.NetworkContractNr = (NetworkContractNr | 0);
        this.NumberCategory = NumberCategory;
        this.ReservedBy = ReservedBy;
        this.ReservedDate = ReservedDate;
        this.ReservedOptionForContractNr = ReservedOptionForContractNr;
        this.ReservedRemark = ReservedRemark;
        this.UnavailableBy = UnavailableBy;
        this.UnavailableDate = UnavailableDate;
        this.UnavailableReason = UnavailableReason;
        this.ActiveVersion = ActiveVersion;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.QuarantineTo = QuarantineTo;
        this.ContractNr = ContractNr;
        this.Langd = Langd;
        this.NetworkIntegrationNr = (NetworkIntegrationNr | 0);
        this.NetworkIntegrationName = NetworkIntegrationName;
        this.ActionEdit = ActionEdit;
        this.ActionUndoQuarantine = ActionUndoQuarantine;
        this.ActionGotoContract = ActionGotoContract;
        this.ActionQuarantine = ActionQuarantine;
        this.ActionRegister = ActionRegister;
        this.ActionReserved = ActionReserved;
        this.ActionUnavailable = ActionUnavailable;
        this.ActionUndoReserved = ActionUndoReserved;
        this.ActionUnregister = ActionUnregister;
    }
}

export function NumberSerieDTO$reflection() {
    return record_type("Containers.NumberInventory.Model.NumberSerieDTO", [], NumberSerieDTO, () => [["ClientNr", int32_type], ["CountryCode", string_type], ["NumberFrom", string_type], ["Version", option_type(string_type)], ["NumberTo", string_type], ["NetworkContractNr", int32_type], ["NumberCategory", option_type(string_type)], ["ReservedBy", option_type(int32_type)], ["ReservedDate", option_type(class_type("System.DateOnly"))], ["ReservedOptionForContractNr", option_type(int32_type)], ["ReservedRemark", option_type(string_type)], ["UnavailableBy", option_type(int32_type)], ["UnavailableDate", option_type(class_type("System.DateOnly"))], ["UnavailableReason", option_type(string_type)], ["ActiveVersion", option_type(string_type)], ["ActiveFrom", option_type(class_type("System.DateOnly"))], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["QuarantineTo", option_type(class_type("System.DateOnly"))], ["ContractNr", option_type(int32_type)], ["Langd", option_type(int32_type)], ["NetworkIntegrationNr", int32_type], ["NetworkIntegrationName", option_type(string_type)], ["ActionEdit", bool_type], ["ActionUndoQuarantine", bool_type], ["ActionGotoContract", bool_type], ["ActionQuarantine", bool_type], ["ActionRegister", bool_type], ["ActionReserved", bool_type], ["ActionUnavailable", bool_type], ["ActionUndoReserved", bool_type], ["ActionUnregister", bool_type]]);
}

